import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LogoLoader from 'components/UI/Spinner/LogoSpinner';
import AccessRestricted from 'components/UI/Common/AccessRestricted';
import { GetUserProfile } from 'store/actions';
import { getPermissionKeyForPath, hasPermission, isSuperAdminUser } from 'utils/permissionUtils';

const PermissionGuard = ({ children, routePath }) => {
  const dispatch = useDispatch();
  const { userData, isLoading } = useSelector(state => ({
    userData: state.user?.userData,
    isLoading: state.user?.isLoading?.GetUserProfile,
  }));

  const authToken = localStorage.getItem('authToken');
  const permissions = userData?.assignablePermissions || {};
  const isSuperAdmin = isSuperAdminUser(userData);
  const permissionKey = getPermissionKeyForPath(routePath);

  useEffect(() => {
    if (authToken && !userData && !isLoading) {
      dispatch(GetUserProfile());
    }
  }, [authToken, userData, isLoading, dispatch]);

  if (authToken && !userData) {
    return <LogoLoader />;
  }

  const hasAccess = hasPermission(permissions, permissionKey, 'view', isSuperAdmin);

  if (!hasAccess) {
    return <AccessRestricted />;
  }

  return children;
};

export default PermissionGuard;
